/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export * from './user-group-assigned-permission-list.component';
export * from './user-group-assigned-permission-list.service';
